import { useEffect, useRef } from "react"

export const useInitialSelectedIds = ({ items, selectedKey = "is_selected", idKey = "id" }) => {
  const initialSelectedIds = useRef([])

  useEffect(() => {
    if (initialSelectedIds.current.length === 0 && Array.isArray(items)) {
      initialSelectedIds.current = items
        .filter((item) => item[selectedKey] && item[idKey] != null)
        .map((item) => item[idKey])
    }
  }, [items, selectedKey, idKey])

  return initialSelectedIds
}
